export enum PiniaStores {
  AUTH_STORE = "AUTH_STORE",
  RATES_STORE = "RATES_STORE",
  APP_STORE = "APP_STORE",
  SOCKET_IO_STORE = "SOCKET_IO_STORE",
  NOTIFICATIONS_STORE = 'NOTIFICATIONS_STORE' 
}
